/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';

export class transaccountreference extends IceEntity {
  trans_account_reference_key: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  trans_account: string = "";
  organization_name: string = "";
  first_name: string = "";
  last_name: string = "";
  initial: string = "";
  prefix: string = "";
  suffix: string = "";
  sex: string = "";
  dob: any = NaN;
  identification_code: string = "";
  identification_code_qualifier: string = "";
  contact_key: string = "";
  communication_number_qualifier: string = "";
  communication_number: string = "";
  communication_type: IceTypes.contacttype = IceTypes.contacttype.ctOther;
  second_contact_key: string = "";
  second_communication_number_qualifier: string = "";
  second_communication_number: string = "";
  second_communication_type: IceTypes.contacttype = IceTypes.contacttype.ctOther;
  relationship_code: string = "";
  emergency_contact: boolean = false;
  provider_code: string = "";
  email: string = "";
  street1: string = "";
  street2: string = "";
  city: string = "";
  state_id: string = "";
  postal_code: string = "";
  province: string = "";
  country_id: string = "";
  enabled: boolean = false;
  record_version: number = 0;
  offline_record_status: number = 0;

  gettablename(): string {
    return "TRANS_ACCOUNT_REFERENCE";
  }
}
